import { JsonSerializable } from '@/util/object/JsonSerializable'
import { RequestCodeVersion } from '@/service/order_info/object/RequestCodeVersion'
import { OrderInfo } from '@/service/order_info/object/OrderInfo'

/**
 * Application required data
 * @class ReservedStorage
 * @extends JsonSerializable
 */
export class ReservedStorage extends JsonSerializable {
  /** @type RequestCodeVersion */
  _codeVersion
  /** @type OrderInfo */
  _orderInfo
  /** @type boolean */
  _isPrintable

  constructor (jsonObject) {
    super()
    if (jsonObject?.codeVersion && jsonObject?.orderInfo) {
      this._codeVersion = RequestCodeVersion.fromJSON(jsonObject.codeVersion)
      this._orderInfo = OrderInfo.fromJSON(jsonObject.orderInfo)
      this._isPrintable = Boolean(String(jsonObject.isPrintable).toLowerCase() === 'true')
    } else if (!jsonObject?.codeVersion) {
      throw new Error('Missing request code')
    } else if (!jsonObject?.orderInfo) {
      throw new Error('Missing original order info')
    }
  }

  /**
   * SV api request code and version
   * @returns {RequestCodeVersion}
   */
  get codeVersion () {
    return this._codeVersion
  }

  /**
   * Original order info response object
   * @return {OrderInfo}
   */
  get orderInfo () {
    return this._orderInfo
  }

  /**
   * Is this RL Printable
   * @returns {boolean} isPrintable
   */
  get isPrintable () {
    return this._isPrintable
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      codeVersion: this._codeVersion?.toJSON(),
      orderInfo: this._orderInfo?.toJSON(),
      isPrintable: this._isPrintable
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {ReservedStorage|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new ReservedStorage(jsonObject)) || undefined
  }
}
